/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';
import AuthService from '../../authService/AuthService';

const ResetPasswordEmailNotificationTokenValidate = data => {
  // console.log(data.token)
  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        `${maverickPortalApiEndPoint.PasswordResetEmailNotificationTokenValidate.url}/${data.token}`,
        maverickPortalApiEndPoint.PasswordResetEmailNotificationTokenValidate.methodType
      )
      .then(response => {
        // if (response.data.Response !== undefined && response.data.Response?.token_data.access_token.length) {
        //    AuthService.login(response.data.Response.token_data.access_token);
        // }
        // else {
        //   console.log(response.data?.Status.StatusDesc)
        // }
        const res = response.data;
        // console.log(res)
        // console.log("From data file")
        resolve({ res });
      });
  });
};

// const logout = () => {
//   return new Promise(function request(resolve) {
//     AuthService.logout();
//   resolve(true);
//   });
// };

export { ResetPasswordEmailNotificationTokenValidate };
